<template>
    <div class="panel-master-container">
    <div id="show-hide-panel-button"  @click="showHidePanel" class="show-hide-panel-button">
        <div id="button-arrow"  class="button-arrow"></div>
    </div>
    <div id="panel-container" class="panel-container">

        <div class="panel-header" v-bind:class="{ 'mosaic': isLayerMosaicsVisible,'bati': isLayerBathymetryVisible, 'sonar': isLayerSonarsVisible }">
            <div class="panel-header-icon" v-bind:class="{ 'panel-header-icon-mosaic': isLayerMosaicsVisible,'panel-header-icon-bati': isLayerBathymetryVisible, 'panel-header-icon-sonar': isLayerSonarsVisible }"></div>
            <div v-if="isLayerMosaicsVisible" >Mosaicos fotograficos   </div>       
            <div v-if="isLayerBathymetryVisible" >Batimetría</div>       
            <div v-if="isLayerSonarsVisible" >Sonar</div>       
        </div>
        <!-- CAPAS -->
        <div class="separator">Mostrar en mapa</div>
        <panelLayers></panelLayers>

        <!-- METADATA & FILTER -->
        <div class="separator"></div>
         <!-- aquí iría el v-if FiltroOrMeta -->
        <div class="pestana-container">
            <div id="pestana1" class="pestana" @click="showHidePestana('meta')">Metadatos</div>
            <div id="pestana2" class="pestana out" @click="showHidePestana('filtro')">Filtrar</div>
        </div>
        <div v-if="this.activePestana == 'meta'">
            <panelMetadata></panelMetadata>   
        </div>
        <div v-if="this.activePestana == 'filtro'">
            <panelFilter></panelFilter>
        </div>

        <!-- INFORMACIÓN -->

        <!-- FILTROS -->
        <div id="panel-filtro">
            <!-- <div id="panel-filtro-header" @click="showHideSection('filtro')">
                <div id="triangle-filtro" class="hide"  v-bind:class="{ 'triangle': theme=='normal','triangle-dark': theme=='dark' }"></div>
                <div v-bind:class="{ 'panel-text-section-dark': theme=='dark' }">Filtrar</div>
            </div> -->
            <div id="panel-filtro-body" ref="panelFiltroBody" class="hide">
                <!-- <FilterPanelMosaics  v-if="isLayerMosaicsVisible" ref="FilterPanelMosaics"></FilterPanelMosaics>
                <FilterPanelSonars  v-if="isLayerSonarsVisible" ref="FilterPanelSonars"></FilterPanelSonars>
                <FilterPanelBathymetry  v-if="isLayerBathymetryVisible" ref="FilterPanelBathymetry"></FilterPanelBathymetry> -->
            </div>
        </div>  
    </div>
    </div>
</template>

<script>
  import {getData} from './../../services/api'
  import { mapGetters } from 'vuex'
  import InfoPanelMosaics from '@/components/map/InfoPanelMosaics'
  import InfoPanelSonars from '@/components/map/InfoPanelSonars'
  import InfoPanel from '@/components/map/InfoPanel'
  import InfoPanelDensityMaps from '@/components/map/InfoPanelParamsDensityMaps'
  import InfoPanelBathymetry from '@/components/map/InfoPanelBathymetry'
  import FilterPanelMosaics from '@/components/map/FilterPanelMosaics'
  import FilterPanelSonars from '@/components/map/FilterPanelSonars'
  import FilterPanelParams from '@/components/map/FilterPanelParams'
  import FilterPanelBathymetry from '@/components/map/FilterPanelBathymetry'

  import panelLayers from '@/components/map/panelLayers'
  import panelMetadata from '@/components/map/panelMetadata'
  import panelFilter from '@/components/map/panelFilter'


  export default {
    name: 'panel',
    data: function () {
        return {
            activePestana: 'meta',
        }
    },
    components: {
        InfoPanelMosaics,
        InfoPanel,
        InfoPanelDensityMaps,
        InfoPanelBathymetry,
        InfoPanelSonars,
        FilterPanelMosaics,
        FilterPanelSonars,
        FilterPanelParams,
        FilterPanelBathymetry,

        panelLayers,
        panelMetadata,
        panelFilter

    },
    computed: {
        ...mapGetters(['platform_id', 'theme','isLayerMosaicsVisible','isLayerBathymetryVisible','isLayerSonarsVisible']),


        mosaicCampaignSelected: {
            get () { return this.$store.state.mapLayers.layerMosaics.mosaicCampaignSelected }
        },
        sonarCampaignSelected: {
            get () { return this.$store.state.mapLayers.layerSonars.sonarCampaignSelected }
        },
        bathymetryCampaignSelected: {
            get () { return this.$store.state.mapLayers.layerBathymetry.bathymetryCampaignSelected }
        },
    },
    watch: {

        'mosaicCampaignSelected': function () {
            this.showHideSection('capas')
            this.showHideSection('filtered')
        },
        'sonarCampaignSelected': function () {
            this.showHideSection('capas')
            this.showHideSection('filtered')
        },
        'bathymetryCampaignSelected': function () {
            this.showHideSection('capas')
            this.showHideSection('filtered')
        },

        'platform_id': function () {
            this.showHideSection('capas')
            this.showHideSection('filtered')
        }
    },
    methods: {
        showHidePanel(){
            var panelButton = document.getElementById("show-hide-panel-button");
            panelButton.classList.toggle("hide");
            var panelContainer = document.getElementById("panel-container");
            panelContainer.classList.toggle("hide");
            var buttonArrow = document.getElementById("button-arrow");
            buttonArrow.classList.toggle("right");
        },
        showHidePestana(section){
            this.activePestana = section;
            let pestana1 = document.getElementById("pestana1");
            let pestana2 = document.getElementById("pestana2");
            pestana1.classList.toggle("out");
            pestana2.classList.toggle("out");
        },
        showHideSection(section){
            var triangle = document.getElementById("triangle-" + section);
            var body = document.getElementById("panel-" + section + "-body");
            triangle.classList.toggle("hide");
            body.classList.toggle("hide");
        },
    }
  }
</script>

<style scoped>
   
    .panel-header{
        justify-content: unset;
    }    
    .panel-header.mosaic{
        background-color: #4c7aae;
    }
    .panel-header.bati{
        background-color: #f3643f;
    }
    .panel-header.sonar{
        background-color: #11a871;
    }
    .panel-header-icon-mosaic {
        background-image: url('~@/assets/img/params/panel-icon-mosaicos.svg');
    }
    .panel-header-icon-bati {
        background-image: url('~@/assets/img/params/panel-icon-bathymetry.svg');
    }
    .panel-header-icon-sonar {
        background-image: url('~@/assets/img/params/panel-icon-sonar.svg');
    }

    #panel-capas-header, #panel-info-header, #panel-filtro-header {
        display: flex;
        flex-direction: row;
        cursor:pointer
    }
    #panel-capas-body, #panel-info-body, #panel-filtro-body {
        padding: 10px 10px 10px 18px;
        overflow: hidden;
        height: 100%;

        -webkit-transition: .1s ease-in-out;
        -moz-transition: .1s ease-in-out;
        -o-transition: .1s ease-in-out;
        transition: .1s ease-in-out;
    }
    #panel-capas-body.hide, #panel-info-body.hide, #panel-filtro-body.hide {
        padding: 0;
        height: 0px;
    }
    .panel-separator{
        height: 1px;
        background-color: #ccc;
        margin: 3px -10px 8px -18px;
    }
    .triangle {
        width: 0;
        height: 0;
        border-top: 5px solid transparent;
        border-left: 10px solid #888;
        border-bottom: 5px solid transparent;
        position: relative;
        top: 7px;
        margin-right: 6px;

        transform: rotate(90deg);
        -webkit-transform: rotate(90deg);
    }
    #triangle-capas.hide, #triangle-info.hide, #triangle-filtro.hide {
        transform: rotate(0deg);
        -webkit-transform: rotate(0deg);
    }
    .panel-content-line{
        font-size: small;
        line-height: 80%;
    }
    .infoPanel {
        padding: 10px 0px 10px 0px !important;
    }
    .infoPanel.hide {
        padding: 0px !important;
    }






    

</style>



// WEBPACK FOOTER //
// src/components/map/panel.vue